module.exports = __webpack_public_path__ + "static/media/am_perm_side_icon_active.243c5004.svg";